import { request } from './http';
import type { PaginatedResult } from '@/types/api';
import type { AdminCardItem, AdminCardListQuery, FreezeCardRequest } from '@/types/card';

export const adminCardsApi = {
  list(query?: AdminCardListQuery) {
    return request<PaginatedResult<AdminCardItem>>({
      url: '/admin/cards',
      method: 'GET',
      params: query,
    });
  },

  /**
   * 冻结卡片：后端会
   *   1) 调用上游 Update a card 将 status 置为 inactive
   *   2) 本地 vcc_card.status -> FROZEN
   *   3) 写 admin_audit_log
   */
  freeze(payload: FreezeCardRequest) {
    return request<AdminCardItem>({
      url: `/admin/cards/${payload.cardId}/freeze`,
      method: 'POST',
      data: { reason: payload.reason },
    });
  },

  unfreeze(cardId: string, reason: string) {
    return request<AdminCardItem>({
      url: `/admin/cards/${cardId}/unfreeze`,
      method: 'POST',
      data: { reason },
    });
  },
};
